import { useEffect, useState } from 'react';
import { useLocalStorage } from '@rehooks/local-storage';

import { STORAGE_USED_PROVIDER } from '@blocks/constants';
import { useSettingsStore } from '@blocks/stores/settings';

/**
 * @param {Object} env
 * @param {Array} providers
 * @returns {Array}
 */
function availableOAuth2Providers(
  { is_apple_oauth2_available = false, is_google_oauth2_available = false },
  providers,
) {
  return [is_apple_oauth2_available && 'apple', is_google_oauth2_available && 'google'].filter(
    available => providers.find(({ provider }) => available === provider),
  );
}

/**
 * XXX dynamic submit handler (depends on rest API)
 */
const useOAuth2 = ({ domain, handler, providers, source_context }) => {
  const { settings, client_utc_offset_min } = useSettingsStore(domain);
  const { env = {} } = settings || {};

  const [usedOAuth2Provider] = useLocalStorage(STORAGE_USED_PROVIDER, '');
  const [submitHandler = () => {}, setSubmitHandler] = useState();

  useEffect(() => {
    if (client_utc_offset_min !== undefined) {
      setSubmitHandler(() =>
        handler({
          utc_offset_min: client_utc_offset_min,
          domain,
          source_context,
          recaptcha_site_key: env?.recaptcha_site_key,
        }),
      );
    }
  }, [client_utc_offset_min, env?.recaptcha_site_key]);

  return {
    isOAuth2Available: !!availableOAuth2Providers(env, providers).length,
    availableOAuth2Providers: availableOAuth2Providers(env, providers),
    usedOAuth2Provider,
    submitHandler,
  };
};

export default useOAuth2;
